import { Link } from "react-router-dom";

function Servicehome({datainfo}){
    console.log (datainfo.subheading);
    let cln=""+ datainfo.class+  " servicebox";
   let hreflink="/"+datainfo.links

return(

<section className={cln} >
<div className="container ">
<div className="contentbanner m-auto text-center pt-4 ">
     
    
        <p className="text-white text-center w-100"> 
           <h1 className="text-white text-center m-auto p-1 ">{datainfo.heading}</h1>
          
          {datainfo.subheading}<br/> {datainfo.subheading2}
      </p>
        <p className=" m-auto"><Link href={hreflink}> 
          <button className="btn btn-light me-3" fdprocessedid="f6epfq"> Learn More</button>
          </Link> <Link href="/contactus">
          <button className="btn btn-primary pe-4  " fdprocessedid="cr0ru">Contact</button>
          </Link> </p>
    
    </div>
    </div>
    </section>
    
)





}

export default Servicehome;